import { toast } from "react-toastify";
import apiClient from "../../../apiClient/apiClient";
import {
  SUBSCRIPTION_REQUEST,
  SUBSCRIPTION_SUCCESS,
  SUBSCRIPTION_FAILURE,
} from "../constant/SubscriptionConstants";

export const subscription = (values) => async (dispatch) => {
  // Validate input
  if (!values.full_name || !values.email) {
    toast.error("Please fill in all fields");
    dispatch({ 
      type: SUBSCRIPTION_FAILURE, 
      payload: "Missing required fields" 
    });
    return false;
  }
  
  dispatch({ type: SUBSCRIPTION_REQUEST });
  
  try {
    // Log what we're actually sending
    console.log("Sending subscription data:", {
      full_name: values.full_name.trim(),
      email: values.email.trim()
    });
    
    // Make API request - ensure we're using the exact field names expected by the backend
    const response = await apiClient.post("subscription/", {
      full_name: values.full_name.trim(),
      email: values.email.trim()
    });
    
    console.log("Subscription success response:", response);
    
    dispatch({
      type: SUBSCRIPTION_SUCCESS,
      payload: response.data,
    });
    
    toast.success('Newsletter subscribed successfully');
    return true;
    
  } catch (error) {
    // Detailed error logging to diagnose the issue
    console.error("Subscription error details:", error.response?.data);
    
    // Check for specific validation errors
    if (error.response?.data?.email) {
      // Handle email validation errors
      const emailError = Array.isArray(error.response.data.email) 
        ? error.response.data.email[0] 
        : error.response.data.email;
        
      if (emailError.includes("already exists")) {
        toast.info("You are already subscribed to the newsletter!");
      } else {
        toast.error(`Email error: ${emailError}`);
      }
    } else if (error.response?.data?.full_name) {
      // Handle name validation errors
      const nameError = Array.isArray(error.response.data.full_name)
        ? error.response.data.full_name[0]
        : error.response.data.full_name;
        
      toast.error(`Name error: ${nameError}`);
    } else if (error.response?.data?.non_field_errors) {
      // Handle general errors
      toast.error(error.response.data.non_field_errors[0]);
    } else {
      // Generic error
      toast.error("Subscription failed. Please try again.");
    }
    
    dispatch({
      type: SUBSCRIPTION_FAILURE,
      payload: error.response?.data || error.message,
    });
    
    return false;
  }
};